module.exports = __webpack_public_path__ + "static/media/locker_room_icon.ba9178ab.svg";